import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, take } from 'rxjs/operators';
import { NotificationService } from '../services/notification.service';

export const adminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const notificationService = inject(NotificationService);

  return authService.userProfile$.pipe(
    take(1),
    map(profile => {
      if (profile && profile.role === 'admin') {
        return true;
      } else {
        notificationService.show('Access Denied: Administrator privileges required.', 'error');
        router.navigate(['/signin'], { queryParams: { returnUrl: state.url } });
        return false;
      }
    })
  );
};
